import styled from "@emotion/styled";
import { ButtonGroup, MenuList } from "@mui/material";
import { StyledTableCell } from "components/Common/Table/StyledTable.styles.ts";

export const SaveDraftTableContainer = styled.div(({ theme }) => ({
	backgroundColor: theme.project.colors.backgroundColors.main,
	padding: 16
}));
export const SaveDraftExteriorTableHeader = styled.div(({ theme }) => ({
	marginBottom: 16,
	display: "flex",
	alignItems: "center",
	justifyContent: "space-between",
	flexWrap: "wrap",
	gap: "16px",
	button: {
		"&.Mui-selected": {
			color: theme.project.colors.primaryColors.main
		}
	},
	span: {
		"&.MuiTabs-indicator": {
			backgroundColor: theme.project.colors.primaryColors.main
		}
	},
	"& > div:last-of-type": {
		display: "flex",
		alignItems: "center"
	},
	[theme.breakpoints.down("md")]: {
		flexDirection: "column",
		alignItems: "flex-start",
		gap: "16px",
		"& > div:last-of-type": {
			gap: "16px",
			flexWrap: "wrap",
			"& > div:first-of-type": {
				display: "flex",
				gap: "16px"
			}
		}
	}
}));
export const SaveDraftFilters = styled.div(({ theme }) => ({
	display: "flex",
	justifyContent: "space-between",
	[theme.breakpoints.down("md")]: {
		display: "block",
		"div:nth-of-type(1)": {
			width: "100%",
			"&.MuiButtonBase-root": {
				justifyContent: "left"
			}
		}
	}
}));

export const SaveDraftTableDisclaimer = styled.div(({ theme }) => ({
	...theme.project.typography.body.body2,
	marginBottom: 16,
	color: theme.project.colors.fontColors.main
}));

export const SaveDraftTableWrapper = styled.div(({ theme }) => ({
	border: theme.project.borders.presets.outline,
	borderWidth: "1px",
	overflowX: "auto",
	[theme.breakpoints.down("md")]: {
		maxHeight: 600,
		overflow: "auto"
	}
}));

export const SaveDraftTableCell = styled(StyledTableCell)(({ theme }) => ({
	padding: "14px 8px 14px 16px",
	verticalAlign: "top",
	wordBreak: "break-word",
	[theme.breakpoints.down("md")]: {
		wordBreak: "normal"
	}
}));

export const SaveDraftTableButtonGroup = styled(ButtonGroup)(({ theme }) => ({
	borderRadius: "4px",
	"& .MuiButtonGroup-firstButton": {
		borderRadius: "4px 0 0 4px"
	},
	"& .MuiButtonGroup-lastButton": {
		borderRadius: "0 4px 4px 0"
	},
	"& .MuiButtonGroup-middleButton": {
		borderRadius: 0
	},
	button: {
		height: "30px",
		padding: "4px 10px",
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		whiteSpace: "nowrap"
	}
}));

export const DraftTableRemovePopover = styled(MenuList)(({ theme }) => ({
	display: "flex",
	alignItems: "center",
	color: theme.project.colors.semanticColors.error,
	padding: "4px 10px",
	gap: "10px",
	button: {
		color: theme.project.colors.semanticColors.error,
		textDecoration: "none",
		height: "32px",
		display: "flex",
		justifyContent: "center",
		alignItems: "center"
	}
}));
